// src/onboarding/OnbButterfly.jsx
// Phase 37 — extracted from src/App.jsx (Plan 37-03).
//
// Phase 31.3 Gap 2 — hero-screen butterfly primitive. Adapted from
// docs/ux-prototypes/prototype-tend-magic-moments.html:2727-2741 (M4 Butterfly
// drift). Renders inside .onb-content (z-index >= 10) so wings cross in front
// of the h1 — unlike OnbBee which rides the background (z-index 5).
// aria-hidden for decorative-only status. Wing-flap and orbit path driven by
// keyframes in src/onboarding.css (onb-butterfly-path + onb-butterfly-flap).
// DEVIATION NOTE: the design-system M4 scene is gated to LATE SUMMER only; this
// plan adopts the butterfly motif year-round on the hero Welcome step. Logged
// in the plan's <deviations> block — revisit if the design system publishes
// guidance against non-seasonal usage.
export default function OnbButterfly({ top = 90, left = "50%", delay = 0, palette = "amber", scale = 1, duration = 13 }) {
  // Two palettes — amber (raspberry+amber accents) and lilac (violet+peach).
  // Pure brand hex values; no new tokens.
  const paints =
    palette === "lilac"
      ? { upper: "#a78bca", upperAccent: "#5a3a70", lower: "#8069a8", body: "#3d2817" }
      : { upper: "#c65d3c", upperAccent: "#5a3f2a", lower: "#a84828", body: "#3d2817" };
  const w = Math.round(36 * scale);
  const h = Math.round(28 * scale);
  return (
    <svg
      aria-hidden="true"
      className="onb-butterfly"
      width={w}
      height={h}
      viewBox="-20 -18 40 36"
      style={{
        position: "absolute",
        top,
        left,
        zIndex: 12, // above .onb-content (10) and .onb-rail (11) so it orbits in front of h1
        pointerEvents: "none",
        animation: `onb-butterfly-path ${duration}s ${delay}s ease-in-out infinite`,
      }}
    >
      {/* upper wings — flap in place via onb-butterfly-flap */}
      <path className="onb-butterfly-wing-l" d="M -6 -2 Q -18 -10 -16 -17 Q -9 -16 -6 -7 Z" fill={paints.upper}/>
      <circle className="onb-butterfly-wing-l" cx="-13" cy="-10" r="2" fill={paints.upperAccent}/>
      <path className="onb-butterfly-wing-r" d="M 6 -2 Q 18 -10 16 -17 Q 9 -16 6 -7 Z" fill={paints.upper}/>
      <circle className="onb-butterfly-wing-r" cx="13" cy="-10" r="2" fill={paints.upperAccent}/>
      {/* lower wings */}
      <path className="onb-butterfly-wing-l" d="M -5 3 Q -15 8 -13 15 Q -7 13 -5 7 Z" fill={paints.lower}/>
      <path className="onb-butterfly-wing-r" d="M 5 3 Q 15 8 13 15 Q 7 13 5 7 Z" fill={paints.lower}/>
      {/* body — sits on top of the wings */}
      <ellipse cx="0" cy="0" rx="1.5" ry="7" fill={paints.body}/>
      <circle cx="0" cy="-7" r="1.5" fill={paints.body}/>
    </svg>
  );
}
